// extracted by mini-css-extract-plugin
export default {"mainContainer":"clientHistory_mainContainer__b+Dkm","orderItem":"clientHistory_orderItem__CP8JV","orderHeading":"clientHistory_orderHeading__yygPK"};